import { render, staticRenderFns } from "./CorpAnnouncement.vue?vue&type=template&id=d2a30fba&"
import script from "./CorpAnnouncement.vue?vue&type=script&lang=js&"
export * from "./CorpAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./CorpAnnouncement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports